import { LocalStorageKey as e } from "../../constants/storage.js";
import { tokenExpired as l } from "./token.js";
const o = () => typeof window < "u", i = "apeiron_auth_session_changed", r = () => {
  o() && window.dispatchEvent(new Event(i));
}, a = () => o() ? localStorage.getItem(e.AccessToken) : null, c = () => o() ? localStorage.getItem(e.RefreshToken) : null, S = (t, n) => {
  const s = a() !== t || !!n && c() !== n;
  localStorage.setItem(e.AccessToken, t), localStorage.removeItem(e.FakeRefreshToken), n && localStorage.setItem(e.RefreshToken, n), s && r();
}, f = (t) => {
  const n = !!a() || !!c();
  localStorage.removeItem(e.AccessToken), localStorage.removeItem(e.RefreshToken), localStorage.removeItem(e.SsoLoginType), n && r();
}, d = () => o() && !!localStorage.getItem(e.FakeRefreshToken) || l(a()), T = (t) => {
  o() && localStorage.setItem(e.Provider, t);
}, h = () => {
  o() && localStorage.removeItem(e.Provider);
}, v = () => {
  if (o())
    return localStorage.getItem(e.Provider);
}, I = (t) => {
  o() && localStorage.setItem(e.ChainType, t);
}, p = () => {
  o() && localStorage.removeItem(e.ChainType);
}, k = () => {
  if (o())
    return localStorage.getItem(e.ChainType);
};
export {
  i as AUTH_SESSION_CHANGED,
  d as accessTokenExpired,
  p as cleanChainType,
  h as cleanProvider,
  f as cleanTokens,
  a as getAccessToken,
  k as getChainType,
  v as getProvider,
  c as getRefreshToken,
  I as saveChainType,
  T as saveProvider,
  S as saveTokens
};
//# sourceMappingURL=index.js.map
